import { ChatCircle } from '@phosphor-icons/react';
import ButtonSpinner from '../ButtonSpinner';
import { busyStyle } from '../../utils/busyStyle';
import { BTN_SECONDARY_SM } from '../buttonStyles';
import { messageLabel } from '../../utils/messageLabel';

/**
 * Message (components.md 3): one control, two shapes. From 1024 up, the
 * inline secondary capsule, the speech bubble at 16 and 6 from "Message",
 * or "Message Ana" where the name is not already on the line. Under 1024,
 * a 44 circle on the grey wash, the bubble at 20 in the label colour, no
 * text, named for assistive tech. Never a capsule on a phone, never a
 * circle on a desktop (decision 111).
 */
export function MessageButton({ name, withName = false, busy = false, onClick, className = '' }: {
  /** The other person's first name, for the label and the circle's aria-label. */
  name: string;
  /** "Message Ana" on the capsule: only where the name is not already on the line. */
  withName?: boolean;
  busy?: boolean;
  onClick: () => void;
  className?: string;
}) {
  const aria = messageLabel(name, true);
  return (
    <>
      <button type="button" onClick={onClick} disabled={busy} aria-busy={busy} style={busyStyle(busy)}
        aria-label={withName ? undefined : aria} data-message-button="capsule"
        className={`${BTN_SECONDARY_SM} max-lg:hidden ${className}`}>
        {busy ? <ButtonSpinner /> : (<><ChatCircle size={16} weight="bold" aria-hidden="true" />{messageLabel(name, withName)}</>)}
      </button>
      <button type="button" onClick={onClick} disabled={busy} aria-busy={busy} style={busyStyle(busy)}
        aria-label={aria} data-message-button="circle"
        className={
          'ios-press flex h-11 w-11 flex-shrink-0 cursor-pointer items-center justify-center rounded-full lg:hidden ' +
          'btn-sec-wash bg-[rgba(120,120,128,0.16)] text-db-text-1 disabled:opacity-40 ' +
          `focus:outline-none focus-visible:ring-2 focus-visible:ring-db-accent/40 ${className}`
        }>
        {busy ? <ButtonSpinner /> : <ChatCircle size={20} weight="regular" aria-hidden="true" />}
      </button>
    </>
  );
}
